import React from 'react';
import {constInvalid, constSend, constValid, constInitialState} from './../../../constants'
import {
    points_request_invalid,
    points_request_send,
    points_request_valid
} from './../actions/getPoints'
import {Svgs} from "../../../components/Svgs";

const initialState = () => ({
    points: constInitialState(),
    currency: parseCurrency(),
    isAuthRequired: true,
});

function parseCurrency(currency) {
    switch (currency) {
        // case 1:
        default:
            return <Svgs type="RUB"/>;
        case 2:
            return <Svgs type="UAH"/>;
        case 3:
            return <Svgs type="BYN"/>;
        case 4:
            return <Svgs type="USD"/>;
        case 5:
            return <Svgs type="EUR"/>;
        case 6:
            return <Svgs type="ALL"/>;
        case 7:
            return <Svgs type="UZS"/>;
        case 8:
            return <Svgs type="KZT"/>;
        case 9:
            return <Svgs type="KGS"/>;
        case 10:
            return <Svgs type="TJS ЅМ"/>;
        case 11:
            return <Svgs type="TMM"/>;
        case 12:
            return <Svgs type="AZN"/>;
    }
}

export const pointsReducer = function (state = initialState(), action) {
    switch (action.type) {
        case points_request_invalid: {
            return {
                ...state,
                points: {
                    ...state.points,
                    ...constInvalid(),
                },
            };
        }
        case points_request_send: {
            return {
                ...state,
                points: {
                    ...state.points,
                    ...constSend(),
                },
            };
        }
        case points_request_valid: {
            return {
                ...state,
                points: {
                    ...state.points,
                    ...constValid(),
                    response: {
                        ...state.points.response,
                        lists: action.data && action.data.points ? action.data.points : []
                    }
                },
                currency: parseCurrency(action.data.currency),
                isAuthRequired: action.data.is_auth_required,
            };
        }
        default:
            return state;
    }
};